<template>
  <div class="fm-statusbar">
    <span class="fm-sb-text">{{ total }} elemento{{ total !== 1 ? 's' : '' }}</span>
    <transition name="fade">
      <span v-if="selectedCount > 0" class="fm-sb-selected">
        · {{ selectedCount }} seleccionado{{ selectedCount !== 1 ? 's' : '' }}
        <span class="fm-sb-size" v-if="totalSize">— {{ formatSize(totalSize) }}</span>
      </span>
    </transition>
    <button
      v-if="selectedCount > 0"
      class="fm-sb-download"
      type="button"
      title="Descargar selección"
      aria-label="Descargar selección"
      @click="$emit('download')"
    >
      <v-icon small dark>mdi-download</v-icon>
      <span>Descargar Selección</span>
    </button>
  </div>
</template>
<script>
import { formatSize } from './dummyData'
export default {
  name: 'FMStatusBar',
  props: { total: Number, selectedCount: Number, selectedItems: Array },
  computed: {
    totalSize() { return (this.selectedItems || []).reduce((s, f) => s + (f.size || 0), 0) }
  },
  methods: { formatSize }
}
</script>
<style scoped>
.fm-statusbar {
  height: var(--fm-statusbar-h);
  background: var(--fm-surface);
  border-top: 1px solid var(--fm-border);
  display: flex; align-items: center;
  padding: 0 16px; gap: 6px;
  font-size: 12px; color: var(--fm-text2);
  flex-shrink: 0;
}
.fm-sb-selected { color: var(--fm-primary); font-weight: 500; }
.fm-sb-size { color: var(--fm-text2); }
.fm-sb-download {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-left: 4px;
  border: 1px solid var(--fm-primary);
  border-radius: var(--fm-radius-sm);
  background: var(--fm-primary);
  color: white;
  cursor: pointer;
  font-family: var(--fm-font);
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  padding: 3px 10px;
  box-shadow: 0 2px 6px rgba(45, 75, 149, 0.22);
}
.fm-sb-download:hover {
  background: var(--fm-primary-dark);
  border-color: var(--fm-primary-dark);
}
.fade-enter-active, .fade-leave-active { transition: opacity 0.15s; }
.fade-enter, .fade-leave-to { opacity: 0; }
</style>
